import {
  ArrowRotateRight,
  CircleCheckFill,
  CircleXmarkFill,
  ClockFill,
  Route,
} from "@gravity-ui/icons";
import {
  Button,
  ButtonView,
  Card,
  Dialog,
  Flex,
  Icon,
  Label,
  Sheet,
  Text,
} from "@gravity-ui/uikit";
import { useAction, useAtom } from "@reatom/npm-react";
import { OrderList } from "definitions/poizon-api";
import { SVGIconData } from "node_modules/@gravity-ui/uikit/build/esm/components/Icon/types";
import { useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { useGravityDevice } from "src/hooks/useGravityDevice";

import {
  cacheOrdersAtom,
  IOrderCache,
  OrderStatuses,
} from "../../store/atoms/cacheOrders";
import { OrderViews } from "../../store/atoms/orderListView";
import { getPoizonTraceOrderWithCache } from "../../store/fetchers/getPoizonTraceOrder";
import { TraceModal } from "../TraceModal/TraceModal";
import css from "./OrderComponentTile.module.scss";
interface OrderProps {
  order: OrderList;
  view: OrderViews;
}
export const OrderComponentTile = ({ order }: OrderProps) => {
  const data = order;
  const { clientId } = useParams();
  const clientIdParams = clientId ?? "0";
  const getTrace = useAction(getPoizonTraceOrderWithCache);
  const [open, setOpen] = useState(false);
  const [orderCache] = useAtom(
    (ctx) => ctx.spy(cacheOrdersAtom)[data.orderNo],
    [data.orderNo],
  );

  const cacheOrderProps = useMemo(
    () => getStatusOrderCacheProps(orderCache),
    [orderCache],
  );
  const { isMobile } = useGravityDevice();

  return (
    <>
      {isMobile ? (
        <Sheet visible={open} onClose={() => setOpen(false)}>
          <Dialog.Body>
            <TraceModal
              clientId={clientIdParams}
              orderNo={data.orderNo}
              imgSrc={data.skuInfo.skuPic}
            />
          </Dialog.Body>
        </Sheet>
      ) : (
        <Dialog open={open} onClose={() => setOpen(false)}>
          <Dialog.Body>
            <TraceModal
              clientId={clientIdParams}
              orderNo={data.orderNo}
              imgSrc={data.skuInfo.skuPic}
            />
          </Dialog.Body>
        </Dialog>
      )}
      <Card className={css.orderCard} view="raised" type="container" size="l">
        <Flex direction="row">
          <Text variant="subheader-2" ellipsis ellipsisLines={2}>
            {data.skuInfo.spuTitle}
          </Text>
          <div>
            <Button
              size="m"
              view={cacheOrderProps?.theme}
              onClick={() => getTrace(clientIdParams, data.orderNo)}
            >
              <Icon data={cacheOrderProps?.icon} fill="#f0f0f0" />
            </Button>
          </div>
        </Flex>

        <Flex justifyContent="space-between" width="100%" gap="8">
          <div className={css.cardCaption}>
            <div>
              <Label type="copy" copyText={data.skuInfo.articleNumber}>
                {data.skuInfo.articleNumber.slice(0, 8)}
              </Label>
            </div>
            <DrawTrackNo data={orderCache} />

            <div onClick={() => setOpen(true)}>
              <Card className={css.priceContainer}>
                <Icon data={Route} />
                <Text variant="subheader-2">
                  {data.skuInfo.skuPrice / 100} ¥
                </Text>
                <Text variant="body-2" color="hint">
                  {data.skuInfo.skuProp}x{data.skuInfo.skuQuantity}
                </Text>
              </Card>
            </div>
          </div>
          <img src={data.skuInfo.skuPic} />
        </Flex>
      </Card>
    </>
  );
};
interface ISOC {
  theme: ButtonView;
  icon: SVGIconData;
}
const getStatusOrderCacheProps = (data: IOrderCache): ISOC => {
  switch (data?.status) {
    case OrderStatuses.unknown:
      return { theme: "flat-danger", icon: CircleXmarkFill };
    case OrderStatuses.done:
      return { theme: "flat-success", icon: CircleCheckFill };
    case OrderStatuses.inTransit:
      return { theme: "flat-utility", icon: ClockFill };
    default:
      return { theme: "flat", icon: ArrowRotateRight };
  }
};

const DrawTrackNo = ({ data }: { data: IOrderCache }) => {
  if (data?.trackNo)
    return (
      <div>
        <Label theme="info" copyText={data.trackNo} type="copy">
          {data.trackNo}
        </Label>
      </div>
    );
  return (
    <div>
      <Label disabled>No track data</Label>
    </div>
  );
};
